module.exports = __webpack_public_path__ + "img/prerogative_2@2x.baad16ba.png";